import {
  getListTransactions, getListWithdrawHistory, setRequestWithdrawal,
  getArtistBalance, getListReport, getListReportHistory, getArtistEarning,
  getListStream, getListPurchase, getListRevenue, getCurrentStream, getArtistEarningSummary,
} from '@/services/transactions';

const getters = {
  listTransaction: state => state.listTransaction,
  listReport: state => state.listReport,
  listReportHistory: state => state.listReportHistory,
  listWithdrawHistory: state => state.listWithdrawHistory,
  listStream: state => state.listStream,
  listPurchase: state => state.listPurchase,
  listRevenue: state => state.listRevenue,
  artistBalance: state => state.artistBalance,
  artistEarning: state => state.artistEarning,
  artistTotalPayout: state => state.artistTotalPayout,
  artistDateReceived: state => state.artistDateReceived,
  streamTotal: state => state.streamTotal,
  streamCurrentTotal: state => state.streamCurrentTotal,
  artistEarningSummary: state => state.artistEarningSummary,
  per_page: state => state.per_page,
};

const actions = {
  async requestListTransactions({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListTransactions({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListReport({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListReport({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_REPORT', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListReportHistory({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListReportHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_REPORT_HISTORY', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListWithdrawHistory({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListWithdrawHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_WITHDRAW_HISTORY', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestListStream({ commit, dispatch, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListStream({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_STREAM', response);
      dispatch('requestCurrentListStream', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestCurrentListStream({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getCurrentStream({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);

      commit('SET_STREAM_CURRENT_TOTAL', response.data.total_stream);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestListPurchase({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListPurchase({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_PURCHASE', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestListRevenue({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListRevenue({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_REVENUE', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestArtistBalance({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const user = rootGetters['AuthModule/getUser'];
      const response = await getArtistBalance({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, user.id);

      commit('SET_ARTIST_BALANCE', response.data.balance ? response.data.balance : 0);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestArtistEarning({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getArtistEarning({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      if (response.data.data !== undefined) {
        commit('SET_ARTIST_EARNING', response.data.data.length > 0 ? response.data.data[0].earning : 0);
        commit('SET_ARTIST_DATE_RECEIVED', response.data.data.length > 0 ? response.data.data[0].payment_date : '');
        commit('SET_ARTIST_TOTAL_PAYOUT', response.data.data.length > 0 ? response.data.data[0].total_payout : 0);
      } else {
        commit('SET_ARTIST_EARNING', 0);
        commit('SET_ARTIST_DATE_RECEIVED', '');
        commit('SET_ARTIST_TOTAL_PAYOUT', 0);
      }
      // commit('SET_ARTIST_BALANCE', response.data.balance);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestWithdrawal({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setRequestWithdrawal({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListWithdrawHistory', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestArtistEarningSummary({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getArtistEarningSummary({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_ARTIST_EARNING_SUMMARY', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST(state, listTransaction) {
    state.listTransaction = listTransaction;
  },
  SET_LIST_REPORT(state, listReport) {
    state.listReport = listReport;
  },
  SET_LIST_REPORT_HISTORY(state, listReportHistory) {
    state.listReportHistory = listReportHistory;
  },
  SET_LIST_WITHDRAW_HISTORY(state, listWithdrawHistory) {
    state.listWithdrawHistory = listWithdrawHistory;
  },
  SET_LIST_STREAM(state, listStream) {
    state.listStream = listStream;
  },
  SET_LIST_PURCHASE(state, listPurchase) {
    state.listPurchase = listPurchase;
  },
  SET_LIST_REVENUE(state, listRevenue) {
    state.listRevenue = listRevenue;
  },
  SET_ARTIST_BALANCE(state, artistBalance) {
    state.artistBalance = artistBalance;
  },
  SET_ARTIST_EARNING(state, artistEarning) {
    state.artistEarning = artistEarning;
  },
  SET_ARTIST_DATE_RECEIVED(state, artistDateReceived) {
    state.artistDateReceived = artistDateReceived;
  },
  SET_ARTIST_TOTAL_PAYOUT(state, artistTotalPayout) {
    state.artistTotalPayout = artistTotalPayout;
  },
  SET_STREAM_TOTAL(state, streamTotal) {
    state.streamTotal = streamTotal;
  },
  SET_STREAM_CURRENT_TOTAL(state, streamCurrentTotal) {
    state.streamCurrentTotal = streamCurrentTotal;
  },
  SET_ARTIST_EARNING_SUMMARY(state, artistEarningSummary) {
    state.artistEarningSummary = artistEarningSummary;
  },
};

export default {
  namespaced: true,
  state: {
    listTransaction: [],
    listReport: [],
    listReportHistory: [],
    listWithdrawHistory: [],
    listStream: [],
    listPurchase: [],
    listRevenue: [],
    artistBalance: 0,
    artistEarning: 0,
    artistTotalPayout: 0,
    artistDateReceived: '',
    streamTotal: 0,
    streamCurrentTotal: 0,
    artistEarningSummary: null,
    per_page: 50,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Transaction/index.js